export default __webpack_public_path__ + "static/media/profile_pic.021764bb.jpeg";